import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FiltrosRepDocNegociables } from '../../models/FiltrosRepDocNegociables';
import { FiltrosComprobanteElectronico } from '../../models/FiltrosComprobanteElectronico';
import { FiltrosComprobanteIF } from '../../models/FiltrosComprobanteIF';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { filter, map, pluck } from "rxjs/operators";
import { FiltrosMarketing } from 'app/models/FiltrosMarketing';
import { FiltrosFacturasLiquidadas } from 'app/models/FiltrosFacturasLiquidadas';
import { FiltrosNotaCD } from 'app/models/FiltrosNotaCD';
import { FiltrosFacturasxCobrar } from 'app/models/FiltrosFacturasxCobrar';
import { FiltrosConciliacionMensual } from 'app/models/FiltrosConciliacionMensual';
import { SessionStorageService } from '../storage/sessionStorage.service';
import { Observable } from 'rxjs';
import { LocalService } from '../storage/localService';
import { FiltrosMarketing2 } from 'app/models/FiltrosMarketing2';
import { ReporteConcar } from 'app/models/ReporteConcar.model';
import { FiltrosConcar } from 'app/models/FiltrosConcar.model';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

  footer: any = ['© Digital Holding']
  bordeFooter: any = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  rellenoFooter: any = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF1F6DBD' }
  };
  bordeHeader: any = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  rellenoHeader: any = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFFFF01' },
    bgColor: { argb: 'FF0000FF' }
  };
  rellenoTotal: any = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFAFC8DB' },
    bgColor: { argb: 'FF0000FF' }
  };
  fuente_letra: any = { name: 'Abadi', family: 4, size: 16, underline: 'double', bold: false };
  fechadescp: any = ['Fecha del Reporte:'];
  idComprobante: any;
  idDesembolso: any;
  datos: any = [];
  header: HttpHeaders;
  message: Observable<any>;
  idEmpresa_Factor: any;
  readonly urlBase = environment.rutaBase;

  constructor(private http: HttpClient,
    private accesoService: AccesoService, private sessionStorageService: SessionStorageService, private localService: LocalService) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  FiltrarReporteListadoDocNegociables(filtros: FiltrosRepDocNegociables) {
    let headers = this.header;
    return this.http
      .get(
        `${this.urlBase}/Reporte/DocumentoNegociable?pTipo_Emision=${filtros.Tipo_Emision}&pTipo_Comprobante=${filtros.Tipo_Comprobante}&pidProveedor=${filtros.IdProv}&pidAdquirente=${filtros.IdAdqui}&pMoneda=${filtros.Moneda}&pEstado=${filtros.Estado}&pDias=${filtros.Dias}`, { headers }
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerListaConciliaciones() {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/Planilla?Opc=PLA`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerListaConciliacionesMensual(filtros: FiltrosConciliacionMensual) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(`${this.urlBase}/Reporte/ConciliacionMensual?Proveedor=${filtros.rucProv}&FechaInicial=${filtros.FechaInicial}&FechaFinal=${filtros.FechaFinal}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  // REVISAR PROCEDIMIENTO ALMACENADO "SP_ReporteMontoPlanilla", HAY TABLAS QUE NO EXISTEN (Contratos, Contratos_Anexos, Contrato_Detalle y Anexos_Detalle)
  // EL API-REPORTABILIDAD TAMPOCO RECIBE EL CAMPO "ESTADO"
  FiltrarListadoCompPago(filtros: FiltrosComprobanteElectronico, fechaD: any, fechaH: any) {
    let headers = this.header;
    return this.http
      .get(
        `${this.urlBase}/Reporte/Planilla?Opc=${filtros.Opc}&pFechaInicial=${fechaD}&pFechaFinal=${fechaH}&pidProveedor=${filtros.IdProv}&pidAdquirente=${filtros.IdAdqui}&pMoneda=${filtros.pMoneda}&pEstado=${filtros.Estado}`, { headers }
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  FiltrarDetallePlanilla(idDesembolso: any) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/Planilla?Opc=CON&pidDesembolso=${idDesembolso}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerReporteComprobantesIF(filtros: FiltrosComprobanteIF) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/ComprobantesIF?idProveedor=${filtros.IdProv}&Tipo=${filtros.Tipo}&Moneda=${filtros.Moneda}&FechaInicial=${filtros.FechaInicial}&FechaFinal=${filtros.FechaFinal}&Estado=${filtros.Estado}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerReportePagodeAdquirentes() {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/PagoAdquirentes`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerReporteMarketing(filtros: FiltrosMarketing) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/DesembolsoAdquirentes`, { headers })
  }

  FiltroListadoRepCobranzaSemanal(FechaInicio: any, FechaFin: any, Moneda) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Reporte/ResumenCobranzaSemanal?FechaInicio=${FechaInicio}&FechaFin=${FechaFin}&Moneda=${Moneda}`, { headers })
  }

  FiltroListadoRepCobranzaMensual(Fecha: any, Moneda) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Reporte/ResumenCobranzaMensual?Periodo=${Fecha}&Moneda=${Moneda}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  FiltroListadoRepFacturasVencidas(FechaV: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Reporte/FacturasVencidas?periodo=${FechaV}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ListadoRepConteoMensual(Fecha: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Reporte/ConteoAdqProvFactMensual?periodo=${Fecha}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerNotaCDEmitidas(filtros: FiltrosNotaCD) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/NotasCD?id_Empresa=1&idProveedor=${filtros.IdProv}&FechaInicial=${filtros.FechaIni}&FechaFinal=${filtros.FechaFin}`, { headers })
  }

  ObtenerFacturasxCobrar(filtros: FiltrosFacturasxCobrar) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/FacturasxCobrar?id_Empresa=1&IdAdquirente=${filtros.IdAdqui}&Moneda=${filtros.Moneda}&FechaInicial=${filtros.FechaIni}&FechaFinal=${filtros.FechaFin}`, { headers })
  }

  ObtenerFacturasLiquidadas(filtros: FiltrosFacturasLiquidadas) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/FacturasLiquidadas?id_Empresa=1&IdAdquirente=${filtros.IdAdqui}&Moneda=${filtros.Moneda}&FechaInicial=${filtros.FechaIni}&FechaFinal=${filtros.FechaFin}`, { headers })
  }

  ObtenerFacturasMensuales(filtros) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(`${this.urlBase}/Reporte/ObtenerReporteMensual?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${filtros.Moneda}&Periodo=${filtros.Periodo}&Serie=${filtros.Serie}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerConciliaciones(filtros) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(`${this.urlBase}/Reporte/ObtenerReporteConciliacion?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${filtros.Moneda}&Desde=${filtros.Desde}&Hasta=${filtros.Hasta}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  ObtenerReporteMarketing2(filtros: FiltrosMarketing2) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Reporte/Marketing2?id_Empresa=1&Ruc=${filtros.Ruc}&FechaInicial=${filtros.FechaIni}&FechaFinal=${filtros.FechaFin}`, { headers })
  }
  
  obtenerReporteConcar(filtros: FiltrosConcar): Observable<ReporteConcar> {
    let headers = this.header;
    return this.http
      .get<ReporteConcar>(`${this.urlBase}/Reporte/ReporteConcar?idEmpresa_Factor=${this.idEmpresa_Factor}&FechaDesde=${filtros.fechaDesde}&FechaHasta=${filtros.fechaHasta}`, { headers })
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }
}
